import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Typography } from "@mui/material";

export const DefaultToast: React.FC = () => {
  return (
    <>
      <ToastContainer
        icon={false}
        position="top-center"
        autoClose={5000}
        closeButton={true}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme="light"
        limit={2}
      />
    </>
  );
};

interface DefaultToastProps {
  title: string;
  message: string;
  delay: number;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
}

export const CustomToast: React.FC<DefaultToastProps> = ({
  title,
  message,
  delay,
  color,
}) => {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + 10
      );
    }, delay);

    return () => {
      clearInterval(timer);
    };
  }, [delay]);

  return (
    <Box flex={1} justifyContent={"center"} alignItems={"center"} gap={2}>
      <Box flex={1} justifyContent={"center"} alignItems={"center"} gap={1}>
        <Typography
          paragraph={true}
          marginBottom={0}
          align="center"
          sx={{
            fontSize: ".75rem",
            fontWeight: "600",
          }}
        >
          {title}
          {"! "}
          <Typography
            variant="caption"
            align="center"
            sx={{ fontSize: ".75rem" }}
          >
            {message}
          </Typography>
        </Typography>
      </Box>
      <Box>
        <CircularProgress
          variant="determinate"
          value={progress}
          color={color}
          size={"27px"}
          sx={{
            position: "absolute",
            top: "7px",
            right: "10px",
            cursor: "pointer",
          }}
        />
      </Box>
    </Box>
  );
};
